import Section from "../../common/Section/Section";
import { SectionComponentProps } from "../../types";
import PillarScores from "../references/components/PillarScores";
import { buildScoresFields, getTotalScore } from "../../../fields/scores";

function Scores({ details, onEdit }: SectionComponentProps) {
  const { pillars } = details;
  const totalScore = getTotalScore(pillars);

  return (
    <Section
      title="Scores"
      columns={2}
      fields={buildScoresFields(pillars)}
      onEdit={() => onEdit("scores")}
      reference={[
        {
          type: "component",
          place: "beneath",
          index: 0,
          item: <PillarScores pillars={pillars} totalScore={totalScore} />,
        },
      ]}
    />
  );
}

export default Scores;
